import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class ProgressBar extends Component {
  render() {
    const { extraClass, isLastStep, totalSteps, currentStep } = this.props;
    const barProgress = isLastStep? 100 : (currentStep/totalSteps) * 100;

    return (
      <div className={"c-progress-bar " + extraClass}>
        <div className="c-progress-bar__bar" style={{
          width: barProgress + '%'
        }}></div>
      </div>
    );
  }
}

export default withTranslation('translations')(ProgressBar);
